import { Button, Grid, Stack, Typography } from '@mui/material'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { getQuizTemplates } from 'app/slices/Quiz'
import { UIAction } from 'app/slices/UI'
import QuizTable from 'components/Quiz/Table'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function Quiz() {
  const dispatch = useAppDispatch()
  const templates = useAppSelector((s) => s.Quiz.templates)
  useEffect(() => {
    if (templates.length === 0) {
      dispatch(getQuizTemplates())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: '問題テンプレート管理',
          url: '/quiz',
        },
      ])
    )
  }, [dispatch])

  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ borderBottom: 2 }}
        >
          問題テンプレート
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Stack
          direction={{
            xs: 'column',
            md: 'row',
          }}
          spacing={1}
          alignItems={{
            xs: 'flex-start',
            md: 'center',
          }}
          justifyContent="space-between"
          my={2}
        >
          <Typography variant="h6" component="h3" fontWeight="bold" ml={1}>
            問題テンプレート一覧
          </Typography>
          <Link to="/quiz/register">
            <Button
              color="secondary"
              variant="contained"
              sx={{
                px: 6,
                borderColor: '#aaa',
                borderRadius: 2,
              }}
            >
              新規登録
            </Button>
          </Link>
        </Stack>
        <QuizTable data={templates} />
      </Grid>
    </Grid>
  )
}
